import {findawayService} from "../plugins/axios";
import {IFindawayPlaylist} from "../models/findaway";

class FindawayService {
  public static async getAudiobookPlaylists(data: any):Promise<IFindawayPlaylist> {
    const dataPl = await findawayService.post(`audiobooks/${data.bookId}/playlists`, {
      "license_id":data.licenseId
    },{
      headers: {
        'Session-Key':data.sessionKey,
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },

    })
    return dataPl.data
  }

}
export default FindawayService
